import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import useLogout from "../Auth/useLogout";
import config from "../../config";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../Component/Loader";

function BecomeTransporter() {
  const navigate = useNavigate();
  const logout = useLogout();
  const user = config.user;
  const [loading, setLoading] = useState(false);
  const [responseError, setResponseError] = useState({
    nameError: "",
    companyNameError: "",
  });
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    gst_number: "",
    company_name: "",
    address: "",
    alternate_phone: "",
    aadhar_number: "",
  });
  const fetchUserProfile = useCallback(async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/customer/profile`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      });

      setFormData((prevData) => ({
        ...prevData,
        name: response.data.data.name ?? "",
        phone: response.data.data.phone ?? "",
        gst_number: response.data.data.user_detail?.gst_number ?? "",
        company_name: response.data.data.user_detail?.company_name ?? "",
        address: response.data.data.user_detail?.company_address ?? "",
      }));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  }, [logout]);
  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateData = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.nameError = "Name is required";
    }
    if (!formData.company_name) {
      newErrors.companyNameError = "Company name is required";
    }

    setResponseError(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateData()) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${config.apiUrl}/customer/become-transporter`,
          {
            name: formData.name,
            phone: formData.phone,
            gst_number: formData.gst_number,
            address: formData.address,
            company_name: formData.company_name,
            alternate_phone: formData.alternate_phone,
            aadhar_number: formData.aadhar_number,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );

        var localData = {
          name: user.name,
          type: "transporter",
          email: user.email,
          phone: user.phone,
        };
        Cookies.set("bz_uinf", JSON.stringify(localData), { expires: 7 });
        config.user =
          Cookies.get("bz_uinf") && JSON.parse(Cookies.get("bz_uinf"));
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        resetData();
        setTimeout(() => {
          navigate("/transporter-products");
        }, 1500);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      } finally {
        setLoading(false);
      }
    }
  };
  const resetData = () => {
    setFormData({
      name: "",
      phone: "",
      gst_number: "",
      company_name: "",
      address: "",
      alternate_phone: "",
      aadhar_number: "",
    });
  };

  return (
    <div className="trns_hero">
      <div className="container-fluid">
        <div className="row gap-row">
          <div className="col-lg-6 mt-4">
            <div className="trns_hero_intro">
              <h4>
                Become a <span className="text-primary">transporter</span>
              </h4>
              <h1>
                We are empowering transporters, accelerating growth—more
                deliveries, fewer hassles.
              </h1>
              <p>
                Experience the freedom to focus on what truly matters while we
                handle the journey.
              </p>
            </div>
          </div>
          <div className="col-lg-6 my-auto p-5 bg-white rounded">
            <h6 className="text-secondary">
              Biznie - Your path to growth: Amply your sales, expand your reach.
            </h6>
            <form className="trns_form" onSubmit={handleSubmit}>
              <div className="row gx-4">
                <div className="col-lg-6">
                  <label htmlFor="name" className="form-label">
                    Name*
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name of person"
                  />
                  {responseError.nameError && (
                    <small className="input-error">
                      {responseError.nameError}
                    </small>
                  )}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="company_name" className="form-label">
                    Company Name*
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="company_name"
                    name="company_name"
                    value={formData.company_name}
                    onChange={handleChange}
                    placeholder="Company name"
                  />
                  {responseError.companyNameError && (
                    <small className="input-error">
                      {responseError.companyNameError}
                    </small>
                  )}
                </div>
                <div className="col-lg-6">
                  <label htmlFor="alternate_phone" className="form-label">
                    Alternate Phone*
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="alternate_phone"
                    name="alternate_phone"
                    value={formData.alternate_phone}
                    onChange={handleChange}
                    placeholder="Alternate phone number"
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="gst_number" className="form-label">
                    GST Number*
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="gst_number"
                    name="gst_number"
                    value={formData.gst_number}
                    onChange={handleChange}
                    placeholder="Gst number"
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="aadhar_number" className="form-label">
                    Aadhar Number*
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="aadhar_number"
                    name="aadhar_number"
                    value={formData.aadhar_number}
                    onChange={handleChange}
                    placeholder="Aadhar number"
                  />
                </div>
                <div className="col-lg-6">
                  <label htmlFor="address" className="form-label">
                    Company Address*
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    placeholder="Company address"
                  />
                </div>
                <div className="col-lg-12">
                  <button
                    type="submit"
                    className="btn btn-success w-100 rounded"
                    disabled={loading}
                  >
                    {loading ? <Loader /> : "Submit"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BecomeTransporter;
